import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { BlockTextareaComponent } from '@app/components/blocks/block-textarea/block-textarea.component';
import { PlTextareaModule } from '@app/components/pl-textarea/pl-textarea.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, PlInputModule, PlTextareaModule],
  declarations: [BlockTextareaComponent],
  exports: [BlockTextareaComponent],
})
export class BlockTextareaModule {}
